import { Tag } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";
import { useTranslation } from "react-i18next";

import { Invitation } from "../../store";

interface Props {
  invitation?: Invitation;
}
const Status = (props: Props) => {
  const { t } = useTranslation();
  const { invitation } = props;
  if (!invitation) return <Tag color="warning">{t("Inactive")}</Tag>;
  const { status } = invitation;
  switch (status) {
    case "active":
      return <Tag color="success">{t("Active")}</Tag>;
    case "invited":
      return <Tag color="processing">{t("Invited")}</Tag>;
  }
  return null;
};

export default observer(Status);
